import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { InfoRow, InfoSection } from './InfoSection';
import { CopyButton } from '../../../../components/CopyButton';
import { ClientAccountInfo } from '../../../../types/clientFullInfo';
import { formatDate } from '../utils';

type ClientDataProps = {
  account: ClientAccountInfo;
};

export const ClientData: React.FC<ClientDataProps> = ({ account }) => {
  const info = account.client;

  const personalRows: InfoRow[] = [
    { label: 'Тип клиента', value: info.isOrganization ? 'Организация' : 'Частное лицо' },
    { label: info.isOrganization ? 'Название организации' : 'ФИО', value: info.orgName || info.name },
    { label: 'Номер телефона', value: info.phone },
    { label: 'Email', value: info.email },
    { label: 'Адрес', value: info.address },
    { label: 'Номер генерального соглашения', value: info.agreement },
    { label: 'Номер торгового счета', value: account.clientCode },
    { label: 'Номер futures code', value: account.futuresCode ?? 'Отсутствует' },
  ];

  if (info.isOrganization) {
    personalRows.push(
      { label: 'ОГРН', value: info.ogrn },
      { label: 'Должность представителя', value: info.representativePosition },
    );
  }

  const riskRows: InfoRow[] = [
    { label: 'Тип', value: info.riskProfileName },
    { label: 'Дата изменения', value: formatDate(info.riskProfileDate) },
    { label: 'GUID', value: info.riskProfileId },
    {
      label: 'Дата соглашения об инвестиционных рекомендациях',
      value: formatDate(info.investmentAdviceAgreementDate),
    },
    { label: 'Тип инвестора', value: info.isQualified ? 'Квалифицированный' : 'Неквалифицированный' },
  ];

  const serviceRows: InfoRow[] = [
    { label: 'Подключенная стратегия', value: info.strategyName },
    { label: 'Идентификатор тарифа стратегии', value: account.strategyTariffId ?? 'Не определен' },
    { label: 'Тариф стратегии', value: account.strategyTariff ?? 'Не определен' },
    { label: 'Дата начала обслуживания', value: formatDate(info.serviceDate) },
    { label: 'Дата закрытия', value: formatDate(info.closeDate) },
    { label: 'Идентификатор соглашения ЭДО', value: info.docFlowAgreementId },
  ];

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Данные клиента</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          gap: 2,
          alignItems: 'stretch',
        }}
      >
        <InfoSection title="Основная информация" rows={personalRows} />
        <InfoSection title="Риск-профиль" rows={riskRows} />
      </Box>
      <InfoSection title="Обслуживание" rows={serviceRows} />
      <Box>
        <CopyButton
          text={JSON.stringify(account, null, 2)}
          label="Копировать данные клиента"
          copiedLabel="Данные скопированы"
        />
      </Box>
    </Stack>
  );
};
